export default {
  relation: [
    {
      title: 'Любой из выбранных',
      value: {
        'id_in': null
      }
    },
    {
      title: 'Все кроме выбранных',
      value: {
        'id_not_in': null
      }
    }
  ],
  date: [
    {
      title: 'От',
      value: 'from',
      symbol: ''
    },
    {
      title: 'До',
      value: 'to',
      symbol: ''
    }
    // {
    //   title: 'Больше',
    //   value: '_gt',
    //   symbol: '>'
    // },
    // {
    //   title: 'Меньше',
    //   value: '_lt',
    //   symbol: '<'
    // },
    // {
    //   title: 'Больше равно',
    //   value: '_gte',
    //   symbol: '>='
    // },
    // {
    //   title: 'Меньше равно',
    //   value: '_lte',
    //   symbol: '<='
    // }
  ],
  valuesIn: [
    {
      title: 'Включить',
      value: '_in'
    },
    {
      title: 'Исключить',
      value: '_not_in'
    }
  ]
}
